/**
 * Coldest LCP & CLS Fix
 *
 * Reserves space for GPO personalization widget (CLS fix)
 *
 * The old fixLCPImage() was removed: it forced eager + fetchpriority=high + a
 * width-800 src onto the FIRST gallery <img> (slide 0, usually hidden), a wasted
 * high-priority download that never touched the visible LCP slide. The visible
 * initial slide is now rendered eager server-side (snippets/responsive-image.liquid)
 * and preloaded from layout/theme.liquid where the theme gallery is shown.
 *
 * DOES NOT TOUCH: engraving preview, tracking scripts, GPO functionality
 */
(function() {
  'use strict';

  /* --- CLS Fix: Reserve space for GPO widget --- */
  function reserveGPOSpace() {
    var style = document.createElement('style');
    style.textContent = [
      '/* CLS fix: reserve space for GPO personalization widget */',
      '.gpo-product-variants { min-height: 0; transition: min-height 0.2s ease; }',
      '/* Reserve space for variant selectors that load late */',
      '.product-area .product-detail { min-height: 200px; }',
      '/* Prevent CLS from review stars loading late */',
      '[data-oke-reviews-widget], .okendo-reviews-widget { min-height: 40px; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  /* Run immediately */
  reserveGPOSpace();

})();
